import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useVisibilityObserver from 'hooks/useVisibilityObserver';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import Bottombar from './Bottombar';
import { currency } from 'helpers/utils';

/* const courseContents = [
 {
  id: 0,
  text: 'Total 13 hours of video lectures',
  icon: 'check'
 },
 {
  id: 1,
  text: '12 premium article access',
  icon: 'check'
 },
 {
  id: 2,
  text: '11 downloadable resources',
  icon: 'check'
 },
 {
  id: 3,
  text: 'Mobile, Tab or TV friendly content',
  icon: 'check'
 },
 {
  id: 4,
  text: 'Certificate upon completion',
  icon: 'check'
 },
 {
  id: 5,
  text: 'Lifetime permission to access',
  icon: 'infinity'
 }
]; */

/* const socialShares = [
 {
  id: 0,
  icon: 'facebook-f',
  color: 'primary'
 },
 {
  id: 1,
  icon: 'twitter',
  color: 'twitter'
 },
 {
  id: 3,
  icon: 'linkedin-in',
  color: 'info'
 }
]; */

const ProjectPricing = ({ data }) => {
 const targetElRef = useRef();
 const { isVisible: inViewport, observer } = useVisibilityObserver(targetElRef, '-100px');

 useEffect(() => {
  return () => {
   observer && targetElRef.current && observer.unobserve(targetElRef.current);
  };
 }, [observer]);

 const handleFacebookShare = () => {
  const currentUrl = window.location.href;
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;
  window.open(facebookShareUrl, '_blank');
 };

 const handleTwitterShare = () => {
  const currentUrl = window.location.href;
  const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
   currentUrl
  )}&text=¡Mira esta proyecto increíble!`;
  window.open(twitterShareUrl, '_blank');
 };

 const handleLinkedInShare = () => {
  const currentUrl = window.location.href;
  const linkedinShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`;
  window.open(linkedinShareUrl, '_blank');
 };

 const handleInstagramLink = () => {
  const instagramProfileUrl = 'https://www.instagram.com/nombre_de_usuario/';
  window.open(instagramProfileUrl, '_blank');
 };

 return (
  <>
   <Card className="mb-3">
    <FalconCardHeader title={data.name} titleTag="h5" className="bg-light d-none d-lg-block mb-0 text-capitalize" />

    <Card.Body>
     <Row>
      <Col md={7} lg={12} className="order-md-1 order-lg-0">
       <h2 className="fw-medium d-flex align-items-center">
        {currency(Math.min(...data.financings.map(e => e.minInitialPay)), true)}
        <span className="ms-2 fs-0 text-500">Separa</span>
        {/* course.oldPrice && <del className="ms-2 fs--1 text-500">${course.oldPrice}</del> */}
       </h2>
       <p className="text-danger fs--1 fw-semi-bold">
        <FontAwesomeIcon icon={['far', 'clock']} className="me-2" />
        La venta termina en 13h : 25m : 54s
       </p>
       <Button ref={targetElRef} variant="primary" size="lg" className="w-100 fs-0 mt-1">
        Cotiza ahora
       </Button>
       <p className="text-700 fw-medium fs--1 mt-3 mb-0">Política de reembolso de 7 días</p>
      </Col>
      <Col md={5} lg={12}>
       <hr className="border-top border-dashed d-md-none d-lg-block" />
       <h6 className="fw-bold">Amenidades</h6>
       <ul className="list-unstyled fs--1 mb-0">
        {data.amenities.map((text, i) => (
         <li key={i} className="mb-1 text-capitalize">
          <FontAwesomeIcon icon="check" className="fs--2 me-2" />
          {text.toLowerCase()}
         </li>
        ))}
       </ul>
      </Col>
     </Row>
     <hr className="border-top border-dashed" />
     <h6 className="fw-bold">Compartir con amigos</h6>
     <Flex className="gap-2">
      <Button
       variant="falcon-default"
       type="button"
       size="sm"
       className="icon-item icon-item-lg fs-0"
       onClick={handleFacebookShare}
      >
       <FontAwesomeIcon icon={['fab', 'facebook-f']} className="mr-1 text-primary" />
      </Button>
      <Button
       variant="falcon-default"
       type="button"
       size="sm"
       className="icon-item icon-item-lg fs-0"
       onClick={handleTwitterShare}
      >
       <FontAwesomeIcon icon={['fab', 'twitter']} className="mr-1 text-twitter" />
      </Button>
      <Button
       variant="falcon-default"
       type="button"
       size="sm"
       className="icon-item icon-item-lg fs-0"
       onClick={handleLinkedInShare}
      >
       <FontAwesomeIcon icon={['fab', 'linkedin-in']} className="mr-1 text-info" />
      </Button>
      <Button
       variant="falcon-default"
       type="button"
       size="sm"
       className="icon-item icon-item-lg fs-0"
       onClick={handleInstagramLink}
      >
       <FontAwesomeIcon icon={['fab', 'instagram']} className="mr-1 text-info" />
      </Button>
     </Flex>
    </Card.Body>
   </Card>
   <Bottombar inViewport={inViewport} price={Math.min(...data.financings.map(e => e.minInitialPay))} />
  </>
 );
};

ProjectPricing.propTypes = { data: PropTypes.object };

export default ProjectPricing;
